import { render, staticRenderFns } from "./ReviewResult.vue?vue&type=template&id=4c82a8b1&scoped=true&"
import script from "./ReviewResult.vue?vue&type=script&lang=js&"
export * from "./ReviewResult.vue?vue&type=script&lang=js&"
import style0 from "./ReviewResult.vue?vue&type=style&index=0&id=4c82a8b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c82a8b1",
  null
  
)

export default component.exports